module.exports = __webpack_public_path__ + "img/bv.b884cec9.svg";